<template>
  <div class="table-responsive mt-3" style="overflow: auto; padding-bottom: 30px; max-height: 60vh">
    <table class="table" style="text-align: center;">
      <thead>
      <tr style="border: 1px solid #EBEDF3">
        <th scope="col" class="header-table" style="min-width: 110px !important;">Mã hóa đơn</th>
        <th scope="col" class="w-[200px] header-table">Tên khách hàng</th>
        <th scope="col" class="w-[140px] header-table">Số điện thoại</th>
        <th scope="col" class="w-[130px] header-table">Số tiền đóng</th>
        <th scope="col" class="w-[120px] header-table">Căn cước công dân</th>
        <th scope="col" class="w-[180px] header-table">Địa chỉ</th>
        <th scope="col" class="w-[150px] header-table">Email</th>
        <th scope="col" class="w-[100px] header-table">ID Trung tâm</th>
        <th scope="col" class="w-[300px] header-table">Kết quả kiểm tra</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item of responseError" :key="item?.index" style="border: 1px solid #EBEDF3; border-top: 0">
        <td style="text-align: start">{{ item?.code }}</td>
        <td style="text-align: start">
          <span style="white-space: nowrap">{{ item?.name }}</span>
        </td>
        <td style="text-align: start">{{ item?.phone }}</td>
        <td style="text-align: start">{{ formatMoney(item?.amount) }}</td>
        <td style="text-align: start">
          <span style="white-space: nowrap">{{ item?.cccd }}</span>
        </td>
        <td style="text-align: start">
          <span style="white-space: nowrap">{{ item?.address }}</span>
        </td>
        <td style="text-align: start">
          <span style="white-space: nowrap">{{ item?.email }}</span>
        </td>
        <td style="text-align: start">
          <span style="white-space: nowrap">{{ item?.center_id }}</span>
        </td>
        <td style="text-align: start">
          <div v-if="item.errors.length > 0" style="text-align: start; display: flex; flex-direction: column; color: red; font-weight: 500">
            <span>Lỗi:</span>
            <span v-for="(error, index) in item.errors" :key="index + error" style="word-break: break-word;">
              - {{error}}
            </span>
          </div>
          <span v-else style="color: #0C9200; font-weight: 500">Đạt</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import {formatPrice} from "@/core/filters";

export default {
  name: 'TableImportError',
  data() {
    return {}
  },
  props: {
    responseError: {
      type: Array,
      required: true,
      default: []
    }
  },
  methods: {
    formatMoney(value) {
      if (value.length > 0 && typeof value == "string") {
        return formatPrice(Number(value));
      }
      return formatPrice(value);
    }
  }
}
</script>

<style lang="css" scoped>
.header-table {
  background: #F8F8F8;
  text-align: start;
  white-space: nowrap;
}
</style>